import styled from 'styled-components';
import {
  color,
  fontSize,
  fontWeight,
  radius,
  shadow,
  spacing,
} from '../../../theme';

export const StyledTeamMember = styled.figure`
  background-color: ${color('white')};
  margin: 0;
  width: 18rem;
  border-radius: ${radius('lg')};
  text-align: left;
  overflow: hidden;
  margin-left: ${spacing('md')};
  margin-right: ${spacing('md')};
  margin-bottom: ${spacing('xs')};
  box-shadow: ${shadow('md')};
`;

export const StyledTeamMemberImg = styled.img`
  display: block;
`;

export const StyledTeamMemberCaption = styled.figcaption`
  background-color: ${color('white')};
  padding: ${spacing('md')};
  font-size: ${fontSize('sm')};
  color: ${color('text_subtle')};

  p {
    margin: 0;
  }
`;

export const StyledTeamMemberTitle = styled.h4`
  font-size: ${fontSize('md')};
  color: ${color('text_default')};
  margin-top: 0;
  margin-bottom: ${spacing('xs2')};
  font-weight: ${fontWeight('black')};
`;
